{
  "AgentOmnichannel_AllowAnsweringConcurrent": "Permettre de répondre à des canaux simultanés :",
  "AgentOmnichannel_Chat_IntegrationType": "Chat Type d'intégration :",
  "AgentOmnichannel_Chat_IDOnChatSystem": "ID On Chat System :",
  "AgentOmnichannel_Chat_LiveChatAgentID": "Livechat Agent ID :",
  "AgentOmnichannel_Email_IntegrationType": "Type d'intégration par courriel :",
  "AgentOmnichannel_Email_EmailAddress": "Adresse électronique :",
  "AgentOmnichannel_Email_IDOnEmailSystem": "ID sur le système de messagerie :",
  "AgentOmnichannel_Chat_IntegrationTypes_None": "[Aucun]",
  "AgentOmnichannel_Chat_IntegrationTypes_LiveChat": "LiveChat",
  "AgentOmnichannel_Email_IntegrationTypes_None": "[Aucun]",
  "AgentOmnichannel_Email_IntegrationTypes_Pop3": "Courrier électronique (POP3 et SMTP)",
  "AgentOmnichannel_Email_EmailAddress_Invalid": "L'adresse électronique n'est pas valide",
  "NAME": "AgentOmnichannel"
}